/* eslint-disable guard-for-in */
import { Pipe, PipeTransform } from '@angular/core';
import * as relativeTime from 'dayjs/plugin/relativeTime';
@Pipe({
    name: 'phoneNumber',
    pure: true
})
export class PhoneNumberPipe implements PipeTransform {

  transform(phoneNumber: string): string {
    if (!phoneNumber) return phoneNumber;
  
    // Handle numbers with country code (e.g., +91 9626720760 or (+1) 463 232 3489)
    const matchInternational = phoneNumber.match(/^(\d{1,3})(\d{10})$/);
    if (matchInternational) {
      return `(+${matchInternational[1]}) ${matchInternational[2].slice(0, 3)} ${matchInternational[2].slice(3, 6)} ${matchInternational[2].slice(6)}`;
    }
  
    // Handle numbers with 2-digit country code and 10-digit local number (e.g., +91 9626720760)
    const matchWithCountryCode = phoneNumber.match(/^\+(\d{2})(\d{10})$/);
    if (matchWithCountryCode) {
      return `+${matchWithCountryCode[1]} ${matchWithCountryCode[2].slice(0, 3)} ${matchWithCountryCode[2].slice(3, 6)} ${matchWithCountryCode[2].slice(6)}`;
    }

    // Handle domestic number with 10 digits (e.g., 9626720760)
    const matchDomestic = phoneNumber.match(/^(\d{10})$/);
    if (matchDomestic) {
      return `${matchDomestic[1].slice(0, 3)} ${matchDomestic[1].slice(3, 6)} ${matchDomestic[1].slice(6)}`;
    }
  
    return phoneNumber;
  }
  
}
